/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
export function DisabledSubmitInput(props) {
    
    return(
        <input {...(props.id && { id: props.id })} {...(props.handle && { onClick: props.handle })} type="submit" data-ripple-light="true" className='z-10 h-full select-none rounded hover:bg-blue-800 bg-sky-950 dark:bg-sky-800 hover:dark:bg-blue-800 py-2.5 px-4 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md dark:shadow-blue-600/20 shadow-blue-800/20 transition-all hover:shadow-lg dark:hover:shadow-blue-600/40 hover:shadow-blue-800/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none peer-placeholder-shown:pointer-events-none peer-placeholder-shown:bg-gray-500 peer-placeholder-shown:opacity-50 peer-placeholder-shown:shadow-none disabled:opacity-50 disabled:bg-sky-950 disabled:shadow-none disabled:hover:bg-sky-950 disabled:hover:dark:bg-sky-800' value={props.value} disabled={!props.state} />
    )
}
